import { render, staticRenderFns } from "./webkamery_detail.vue?vue&type=template&id=3942f3ae&"
import script from "./webkamery_detail.vue?vue&type=script&lang=js&"
export * from "./webkamery_detail.vue?vue&type=script&lang=js&"
import style0 from "./webkamery_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports